import type { ApiError } from '@/utils/types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  reportProductionPeriod,
  fetchProductionReportById,
  type ProductionReportInput,
} from '../api/production-report.api';

export const getProductionReportById = createAsyncThunk(
  'ProductionReporting/getProductionReportById',
  async ({ reportId }: { reportId: string }, thunkAPI) => {
    try {
      return await fetchProductionReportById({ reportId });
    } catch (e: unknown) {
      return thunkAPI.rejectWithValue(
        (e as ApiError).message || 'Failed to fetch production report'
      );
    }
  }
);

export const postProductionReport = createAsyncThunk(
  'ProductionReporting/postProductionReport',
  async (body: ProductionReportInput, thunkAPI) => {
    try {
      return await reportProductionPeriod(body);
    } catch (e: unknown) {
      return thunkAPI.rejectWithValue(
        (e as ApiError).message || 'Failed to create production report'
      );
    }
  }
);
